import React from 'react';
import { withStyles } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';

import { useThemeContext } from '../../../services/ThemeService';
import styles from './styles';

const darkModeHeroLogoSrc = `${process.env.PUBLIC_URL}/branding/pinn-hub-logo.png`;
const lightModeHeroLogoSrc = `${process.env.PUBLIC_URL}/branding/pinn-hub-logo-light.png`;

const Introduction = (props) => {
    const { classes } = props;
    const { themeName } = useThemeContext();
    const heroLogoSrc = themeName === 'light' ? lightModeHeroLogoSrc : darkModeHeroLogoSrc;

    return (
        <Container maxWidth={false} className={classes.blockContainer}>
            <div className={classes.mainBlock}>
                <Typography variant="overline" className={classes.eyebrow}>
                    NextGen PINN Hub
                </Typography>
                <img
                    alt="PINN Hub logo"
                    className={classes.heroLogo}
                    src={heroLogoSrc}
                />
                <Typography variant="h1" className={classes.mainTitleText}>
                    A sharper home for NeuroDiffEq-based PINN solvers.
                </Typography>
                <Typography variant="subtitle1" className={classes.mainTitleDescription}>
                    PINN Hub today is a focused solver-sharing workspace for browsing, versioning, downloading, and discussing ODE and PDE models built with the NeuroDiffEq library. It is not yet the broader multi-framework execution platform described in the long-term product vision.
                </Typography>
                <div className={classes.actionRow}>
                    <Button
                        component={Link}
                        to="/solutions"
                        variant="contained"
                        color="primary"
                    >
                        Explore Solutions
                    </Button>
                    <Button
                        component={Link}
                        to="/docs/getting_started"
                        variant="outlined"
                        color="primary"
                    >
                        Read NeuroDiffEq Docs
                    </Button>
                </div>
            </div>
        </Container>
    );
};

export default withStyles(styles)(Introduction);
